module.exports = __webpack_public_path__ + "img/hr.10f230d5.webp";